"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueOfNoticeType = exports.FlatLotNoticeType = void 0;
var FlatLotNoticeType;
(function (FlatLotNoticeType) {
    FlatLotNoticeType["ALL"] = "All";
    FlatLotNoticeType["AWARD"] = "contract award";
    FlatLotNoticeType["CONTRACT"] = "contract notice";
    FlatLotNoticeType["PRIOR_INFORMATION"] = "prior information notice";
    FlatLotNoticeType["EX_TRANSPARENCY"] = "voluntary ex ante transparency notice";
    FlatLotNoticeType["DYNAMIC_PURCHASING_SYSTEM"] = "dynamic purchasing system";
})(FlatLotNoticeType = exports.FlatLotNoticeType || (exports.FlatLotNoticeType = {}));
const getValueOfNoticeType = (enumKey) => {
    return FlatLotNoticeType[enumKey];
};
exports.getValueOfNoticeType = getValueOfNoticeType;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmxhdC1sb3Qtbm90aWNlLXR5cGUuZW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9sb3QvdHlwZXMvZmxhdC1sb3Qtbm90aWNlLXR5cGUuZW51bS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7Ozs7OztHQU1HOzs7QUFFSCxJQUFZLGlCQU9YO0FBUEQsV0FBWSxpQkFBaUI7SUFDM0IsZ0NBQVcsQ0FBQTtJQUNYLDZDQUF3QixDQUFBO0lBQ3hCLGlEQUE0QixDQUFBO0lBQzVCLG1FQUE4QyxDQUFBO0lBQzlDLDhFQUF5RCxDQUFBO0lBQ3pELDRFQUF1RCxDQUFBO0FBQ3pELENBQUMsRUFQVyxpQkFBaUIsR0FBakIseUJBQWlCLEtBQWpCLHlCQUFpQixRQU81QjtBQUVNLE1BQU0sb0JBQW9CLEdBQUcsQ0FBQyxPQUF1QyxFQUFFLEVBQUU7SUFDOUUsT0FBTyxpQkFBaUIsQ0FBQyxPQUFPLENBQUMsQ0FBQztBQUNwQyxDQUFDLENBQUM7QUFGVyxRQUFBLG9CQUFvQix3QkFFL0IifQ==